/**
 * JT Assets services
 *
 * Contact: apiteam@swagger.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErrorResponseData { 
    /**
     * Code of the response
     */
    code?: string;
    /**
     * Type of the response
     */
    type?: ErrorResponseData.TypeEnum;
    /**
     * Message of the response
     */
    message?: string;
}
export namespace ErrorResponseData {
    export const TypeEnum = {
        Error: 'ERROR',
        Warn: 'WARN'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


